module.exports = __webpack_public_path__ + "img/logo@2x.c270b9be.png";